// https://en.wikipedia.org/wiki/Year_2038_problem
export const permanentCookieExpirationDate = new Date(2038, 0, 1);
export const permanentCookieExpiration = permanentCookieExpirationDate.getTime();
